<template>
  <VueModal :name="name" width="90%" height="auto" :maxWidth="750" :classes="['v--modal', 'recyco-modal']" v-bind="$attrs">
    <slot />
  </VueModal>
</template>

<script>
  export default {
    name: 'recyco-modal',
    props: {
      name: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
  .recyco-modal {
    border-radius: 1rem;
  }
</style>
